import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
import _extends from "/app/node_modules/babel-runtime/helpers/extends";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as stepperComponents from "~/components/stepper";
import ProgressMovil from "~/components/progress-movil";
import { SaveAfiliation, NotAffiliationFinalized } from "~/components/modals";
import { mapState, mapMutations, mapGetters } from "vuex";
import { NoContentError } from "~/abstractions/errors";
import Loader from "~/components/modals/loader";

export default {
  layout: "stepped",
  components: _extends({}, stepperComponents, {
    ProgressMovil: ProgressMovil,
    SaveAfiliation: SaveAfiliation,
    NotAffiliationFinalized: NotAffiliationFinalized,
    Loader: Loader
  }),
  fetch: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var store = _ref.store,
          app = _ref.app,
          query = _ref.query,
          redirect = _ref.redirect;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              store.commit("dashboard/details/setToolbarTitle", "New Affiliation");
              store.commit("affiliations/form/setShowSteppeds", false);
              store.commit("dashboard/details/setLeaveToDashboard", false);
              _context.next = 5;
              return store.dispatch("master-data/getProducts");

            case 5:
              _context.next = 7;
              return store.dispatch("master-data/findAllTypeDevelopment");

            case 7:
              _context.next = 9;
              return store.dispatch("master-data/findAllPlatform");

            case 9:
              _context.prev = 9;
              _context.next = 12;
              return store.dispatch("affiliations/form/loadFromAffiliationProcess", query);

            case 12:
              _context.next = 14;
              return store.dispatch("affiliations/form/loadUbigeoData");

            case 14:
              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](9);

              if (_context.t0 instanceof NoContentError) redirect("/dashboard");else app.$controlMessage(_context.t0);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[9, 16]]);
    }));

    function fetch(_x) {
      return _ref2.apply(this, arguments);
    }

    return fetch;
  }(),
  asyncData: function asyncData(_ref3) {
    var app = _ref3.app,
        redirect = _ref3.redirect;

    if (app.$isAdmin() || app.$isBoss()) return redirect("/dashboard");

    return null;
  },
  data: function data() {
    return {
      dialog: false,
      loading: false,
      closeNewAffiliation: false,
      loaderMessage: null,
      logout: false
    };
  },

  computed: _extends({}, mapGetters({
    showSteppeds: ["affiliations/form/showSteppeds"]
  }), mapState({
    stepNumber: function stepNumber(state) {
      return state.affiliations.form.step;
    },
    idAffiliationProcess: function idAffiliationProcess(state) {
      return state.affiliations.form.idAffiliationProcess;
    },
    leaveToDashboard: function leaveToDashboard(state) {
      return state.dashboard.details.leaveToDashboard;
    },
    registerStatus: function registerStatus(state) {
      return state.affiliations.form.registerStatus;
    },
    onHold: function onHold(state) {
      return state.affiliations.form.onHold;
    },
    logoutAffiliation: function logoutAffiliation(state) {
      return state.affiliations.form.logoutInAffiliation;
    },
    multiAdress: function multiAdress(state) {
      return state.affiliations.form.multiAdress;
    }
  }), {
    step: {
      get: function get() {
        return this.$store.state.affiliations.form.step;
      },
      set: function set(val) {
        // console.log('stepper val', val)
        this.$store.commit("affiliations/form/setStepNumber", val);
      }
    },
    isMovil: function isMovil() {
      return this.$vuetify.breakpoint.name == "sm" || this.$vuetify.breakpoint.name == "xs";
    },
    conditionalStepName8: function conditionalStepName8() {
      if (this.$isPresential()) return 9;else if (this.$isPagoLink()) return 7;else return 8;
    },
    conditionalStepName9: function conditionalStepName9() {
      if (this.$isPresential()) return 10;else if (this.$isPagoLink()) return 8;else return 9;
    },
    conditionalStepName10: function conditionalStepName10() {
      if (this.$isPresential()) return 11;else if (this.$isPagoLink()) return 9;else return 10;
    },
    conditionalVstepperContent: function conditionalVstepperContent() {
      if (this.$isPresential()) return 8;else if (this.$isPagoLink()) return 15;else return 6;
    },
    conditional: function conditional() {
      if (this.$isPagoLink() && this.$isVirtual()) return 6;else return 7;
    }
  }),
  methods: _extends({}, mapMutations({
    setLeaveToDashboard: "dashboard/details/setLeaveToDashboard"
  }), {
    exit: function exit() {
      var _this = this;

      console.log("Proceso salida");
      console.log("isPresential", this.$isPresential());
      console.log("isPagoWeb", this.$isPagoWeb());
      console.log("isPagoApp", this.$isPagoApp());
      console.log("isPagoLink", this.$isPagoLink());
      console.log("step", this.step);
      console.log("idAffiliationProcess", this.idAffiliationProcess);
      var step = void 0;
      if (this.$isPresential()) {
        // TODO: No borrar, preguntar comportamiento
        // if(this.step == 10) {
        if (this.step == 8) {
          this.setLeaveToDashboard(true);
          this.$nextTick(function () {
            this.$router.push("/dashboard");
          });
          setTimeout(function () {
            try {
              _this.$store.commit("affiliations/form/finishAffiliation");
            } catch (error) {
              _this.$controlMessage(error);
            }
          }, 2500);
        } else {
          this.$refs.saveAffiliationModal.showModal();
        }
      } else if (this.$isPagoWeb() || this.$isPagoApp()) {
        // TODO: No borrar, preguntar comportamiento
        // if(this.step == 9) {
        if (this.step == 9) {
          this.setLeaveToDashboard(true);
          this.$nextTick(function () {
            this.$router.push("/dashboard");
          });
          setTimeout(function () {
            try {
              _this.$store.commit("affiliations/form/finishAffiliation");
            } catch (error) {
              _this.$controlMessage(error);
            }
          }, 2500);
        } else {
          this.$refs.saveAffiliationModal.showModal();
        }
      } else if (this.$isPagoLink()) {
        // TODO: No borrar, preguntar comportamiento
        // if(this.step == 8) {
        if (this.step == 8) {
          this.setLeaveToDashboard(true);
          this.$router.push("/dashboard");
          setTimeout(function () {
            try {
              _this.$store.commit("affiliations/form/finishAffiliation");
            } catch (error) {
              _this.$controlMessage(error);
            }
          }, 2500);
        } else {
          this.$refs.saveAffiliationModal.showModal();
        }
      }
    },
    closeWithoutSaveAffiliation: function closeWithoutSaveAffiliation() {
      var _this2 = this;

      console.log("Cerrando sin guardar");
      this.setLeaveToDashboard(true);
      this.$router.push("/dashboard");
      setTimeout(function () {
        try {
          _this2.$store.commit("affiliations/form/finishAffiliation");
        } catch (error) {
          _this2.$controlMessage(error);
        }
      }, 2500);
    },
    returnModal: function returnModal() {
      this.$refs.saveAffiliationModal.showModal();
    },
    saveAffiliationWorked: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(idReason) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // console.log("entra aca 2");
                this.loaderMessage = "Guardando afiliación como trabajada";
                this.$refs.loader.showLoader();
                _context2.prev = 2;
                _context2.next = 5;
                return this.$store.dispatch("affiliations/form/saveAffiliationWorked", {
                  idReason: idReason,
                  noSpecified: true
                });

              case 5:
                this.setLeaveToDashboard(true);

                if (!this.logoutAffiliation) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 9;
                return this.$store.dispatch("user/loginOut");

              case 9:
                this.$router.push("/");
                _context2.next = 13;
                break;

              case 12:
                this.$nextTick(function () {
                  this.$router.push("/dashboard");
                });

              case 13:
                _context2.next = 18;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](2);

                this.$controlMessage(_context2.t0);

              case 18:
                this.$refs.loader.closeLoader();

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 15]]);
      }));

      function saveAffiliationWorked(_x2) {
        return _ref4.apply(this, arguments);
      }

      return saveAffiliationWorked;
    }(),
    saveAffiliationProcess: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // console.log('entra aca 1')
                this.loaderMessage = "Guardando afiliación en proceso";
                this.$refs.loader.showLoader();
                _context3.prev = 2;
                _context3.next = 5;
                return this.$store.dispatch("affiliations/form/saveAffiliationProcess", { isSaved: true });

              case 5:
                this.setLeaveToDashboard(true);

                if (!this.logoutAffiliation) {
                  _context3.next = 12;
                  break;
                }

                _context3.next = 9;
                return this.$store.dispatch("user/loginOut");

              case 9:
                this.$router.push("/");
                _context3.next = 13;
                break;

              case 12:
                this.$nextTick(function () {
                  this.$router.push("/dashboard");
                });

              case 13:
                _context3.next = 18;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](2);

                this.$controlMessage(_context3.t0);

              case 18:
                this.$refs.loader.closeLoader();

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 15]]);
      }));

      function saveAffiliationProcess() {
        return _ref5.apply(this, arguments);
      }

      return saveAffiliationProcess;
    }()
  }),
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // TODO: No borrar, preguntar comportamiento
    if (this.$refs.saveAffiliationModal && !this.leaveToDashboard && !this.idAffiliationProcess) {
      this.$refs.saveAffiliationModal.showModal();
      next(false);
    } else {
      next();
    }
  }
  // mounted() {
  //     this.$nextTick(function () {
  //         this.$store.dispatch('affiliations/form/loadUbigeoData')
  //         this.$store.commit('dashboard/details/setLeaveToDashboard', false)
  //     })
  // },

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/new-affiliation.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/new-affiliation.vue
// module chunks = 2